import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvestpackService } from '@app/investment/investpack.service';
import { AlertService } from '@service/alert.service';
import { FireAnalyticsService } from '@service/fire-analytics.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-update-holdings-dialog',
  templateUrl: './update-holdings-dialog.component.html',
  styles: []
})
export class UpdateHoldingsDialogComponent implements OnInit {

  subscribedPacks: any[] = []
  isInvested: boolean = false;
  investpackInstruments: any[] = []
  updateInvestpackForm: FormGroup
  selectedSubscription: any;
  previousInvestment: any[] = [];
  stockBaseUrl: string = '';
  isLoading: boolean = false
  
  constructor(
    private dialogRef: MatDialogRef<UpdateHoldingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private investpackService: InvestpackService,
    private fb: FormBuilder,
    private alertService: AlertService,
    private analytics: FireAnalyticsService
  ) { }

  ngOnInit(): void {
    this.getSubscribedPacks()
  }


  getSubscribedPacks(){
    this.investpackService.subscribedPortfolio(`status=ACTIVE`).subscribe((res)=>{
      this.stockBaseUrl = res.stockBaseUrl
      this.subscribedPacks = res.data.map((x)=>{
        x.wealthcaseName = x.wealthcase.name
        return x
      })
    })
  }

  selectedPack(subscriptionID:string){
    this.isLoading = true
    this.selectedSubscription = this.subscribedPacks.find((x)=>  x._id === subscriptionID)
    this.isInvested = this.selectedSubscription.isInvested
    this.analytics.logEvents('Select Investpack', {investpack: this.selectedSubscription.wealthcase.name})
    this.investpackService.holdings(`?isWealthcaseInv=true&wealthcase=${this.selectedSubscription.wealthcase._id}`).pipe(finalize(()=> this.isLoading = false)).subscribe((res)=>{
      if(this.isInvested){
        // this.previousInvestment = this.selectedSubscription.wealthcase.instruments.filter((x)=> x.quantity)
        this.investpackInstruments = res.data.filter((x)=> x.quantity)
      } else {
        this.investpackInstruments = this.selectedSubscription.wealthcase.instruments.filter((x)=> x.quantity)
      }
      this.initializeForm()
    })
  }

  initializeForm(){
    this.updateInvestpackForm = this.fb.group({
      instruments: this.fb.array([])
    })
    this.investpackInstruments.forEach((instrument)=>{
      this.addInstrument(instrument)
    })
  }

  addInstrument(instrument): void {
    (this.updateInvestpackForm.get('instruments') as FormArray).push(this.newInstrument(instrument));
  }

  newInstrument(instrument) {
    if(this.isInvested){
      let form = this.fb.group({
        name: [instrument.category === 'mutual_fund' ? instrument.name : instrument.tradingSymbol, Validators.required],
        category: [instrument.category, Validators.required],
        instrument: [instrument._id, Validators.required],
        purchasePrice: [instrument.currentPrice, Validators.required],
        oldQuantity: [instrument.quantity, Validators.required],
        newQuantity: [instrument.quantity, Validators.required],
        scriptType: ['BUY']
      })
      // let prevInvested = this.previousInvestment.find((x)=> x.instrumentToken === instrument.instrumentToken)
      // if(prevInvested){
      //   form.controls['oldQuantity'].patchValue(prevInvested.quantity)
      // }
      form.controls['oldQuantity'].disable();
      return form
    } else{
      return this.fb.group({
        name: [instrument.category === 'mutual_fund' ? instrument.name : instrument.tradingSymbol, Validators.required],
        category: [instrument.category, Validators.required],
        instrument: [instrument._id, Validators.required],
        purchasePrice: [instrument.currentPrice, Validators.required],
        quantity: [instrument.quantity, Validators.required],
        scriptType: ['BUY']
      })
    }
  }

  getControlsArr() {
    return this.updateInvestpackForm.get('instruments') as FormArray
  }

  close(value: boolean){
    if(!value){
      this.analytics.logEvents('Cancel Update Investpack')
    }
    this.dialogRef.close(value)
  }

  changeCurrentQty(index){
    let formGroup = (this.updateInvestpackForm.get('instruments') as FormArray).at(index)
    if(formGroup.get('oldQuantity').value > formGroup.get('newQuantity').value){
      formGroup.get('scriptType').patchValue('SELL')
    } else{
      formGroup.get('scriptType').patchValue('BUY')
    }
  }


  updateExternalHolding(){
    let instruments: any[] = []
    let totalInsvestment = 0
    this.investpackInstruments.forEach(element => {
      let instruData = {
        _id: element._id,
        tradingSymbol: element.tradingSymbol,
        exchange: element.exchange,
        quantity: element.quantity,
        investment: element.investment,
        scriptType: "BUY",
        orderStatus: "success",
        validity: "DAY",
        price: element.currentPrice,
        category: element.category
      }
      let formData = this.updateInvestpackForm.controls['instruments'].value.find(x => x.instrument === element._id)
      instruData.scriptType = formData.scriptType
      instruData.price = formData.purchasePrice
      if(this.isInvested){
        if((formData.newQuantity - instruData.quantity) !== 0){
          if(instruData.scriptType === 'BUY'){
            instruData.quantity =  formData.newQuantity - instruData.quantity
          } else {
            instruData.quantity = instruData.quantity - formData.newQuantity
          }
          totalInsvestment += ((this.isInvested ?  formData.newQuantity : formData.quantity) * formData.purchasePrice)
          instruments.push(instruData)
        }
      } else {
        instruData.quantity = formData.quantity
        totalInsvestment += ((this.isInvested ?  formData.newQuantity : formData.quantity) * formData.purchasePrice)
        instruments.push(instruData)
      }
      
    });

    let data = {
      subscription: this.selectedSubscription._id,
      platform: "other",
      investments: totalInsvestment,
      instruments: instruments,
      status: "success"
    }
    if(instruments.length){
      this.investpackService.createExternalOrders(data).subscribe((res)=>{
        this.analytics.logEvents('Investpack Transaction Updated', {investpack: this.selectedSubscription.wealthcase.name, amount: totalInsvestment})
        this.alertService.success(res.message)
        this.close(true)
      })
    } else {
      this.close(true)
    }
  }
}
